var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Icon = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 20 : _c;
    return (React.createElement("svg", { className: "sb-icon " + className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, children));
};
export var PinIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" }),
    React.createElement("circle", { cx: "12", cy: "9.5", r: "2.5" }))); };
export var HomeIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M3.5 11L12 4.5l8.5 6.5M5.5 9.5V20h13V9.5" }))); };
export var CalendarIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("rect", { x: "3.5", y: "5", width: "17", height: "15.5", rx: "2" }),
    React.createElement("path", { d: "M3.5 10h17M8 3v4M16 3v4" }))); };
export var CalendarPlusIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("rect", { x: "3.5", y: "5", width: "17", height: "15.5", rx: "2" }),
    React.createElement("path", { d: "M3.5 10h17M8 3v4M16 3v4M12 13v5M9.5 15.5h5" }))); };
export var ClockIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("circle", { cx: "12", cy: "12", r: "8.5" }),
    React.createElement("path", { d: "M12 7.5V12l3 2" }))); };
export var PhoneIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M5 4h3.2l1.6 4-2 1.3a11 11 0 0 0 4.9 4.9l1.3-2 4 1.6V17a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z" }))); };
export var PersonIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("circle", { cx: "12", cy: "8", r: "3.8" }),
    React.createElement("path", { d: "M4.5 20.5a7.5 7.5 0 0 1 15 0" }))); };
export var XCircleIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("circle", { cx: "12", cy: "12", r: "8.5" }),
    React.createElement("path", { d: "M9.2 9.2l5.6 5.6M14.8 9.2l-5.6 5.6" }))); };
export var LinkOffIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1M4 4l16 16" }))); };
export var ChevronLeftIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M14.5 6l-6 6 6 6" }))); };
export var ChevronDownIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M6 9.5l6 6 6-6" }))); };
export var CheckIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M5 12.5l4.5 4.5L19 7.5" }))); };
export var CheckCircleIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 20 : _c;
    return (React.createElement("svg", { className: "sb-icon " + className, width: size, height: size, viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false" },
        React.createElement("circle", { cx: "12", cy: "12", r: "10", fill: "currentColor" }),
        React.createElement("path", { d: "M7.5 12.3l3 3 6-6.3", fill: "none", stroke: "#fff", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round" })));
};
